'use client'
import { Button, Icon, type IconNames } from '@repo/ui/components'
import { useTheme } from 'next-themes'
import gsap from 'gsap'
import { useEffect, useRef, useState } from 'react'

export const ThemeButton = () => {
  const [mounted, setMounted] = useState(false)
  const { theme, systemTheme, setTheme } = useTheme()

  const iconRef = useRef<HTMLSpanElement>(null)

  const themeIcon: Record<'light' | 'dark' | 'system', IconNames> = {
    light: 'SunGhost',
    dark: 'MoonGhost',
    system: 'AutoSunMoonLine',
  }
  const firstTheme = systemTheme === 'dark' ? 'light' : 'dark'
  const secondTheme = systemTheme === 'dark' ? 'dark' : 'light'
  const handleThemeChange = () => {
    if (iconRef.current) {
      gsap.to(iconRef.current, {
        rotate: 90,
        opacity: 0,
        duration: 0.2,
        ease: 'power2.in',
        onComplete: () => {
          setTheme(
            theme === 'system'
              ? firstTheme
              : theme === secondTheme
                ? 'system'
                : secondTheme,
          )
          gsap.fromTo(
            iconRef.current,
            { rotate: -90, opacity: 0 },
            { rotate: 0, opacity: 1, duration: 0.2, ease: 'power2.out' },
          )
        },
      })
    } else {
      setTheme(
        theme === 'system'
          ? firstTheme
          : theme === secondTheme
            ? 'system'
            : secondTheme,
      )
    }
  }

  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <Button
      variant='transparent'
      color='neutral'
      size='sm'
      onClick={handleThemeChange}
      aria-label='Toggle Theme'
      startIcon={
        <span ref={iconRef} className='inline-flex'>
          {theme && (
            <Icon
              name={themeIcon[theme as keyof typeof themeIcon]}
              className='h-5 w-5'
            />
          )}
        </span>
      }
    />
  )
}
